module.exports = __webpack_public_path__ + "img/css.fb88a9e7.svg";